import { environment } from './env';

export const isE2eOrA11y = () => {
	return isE2e() || isA11y();
};

export const isE2e = () => {
	return environment.PUBLIC_ENV === 'e2e';
};

export const isA11y = () => {
	return environment.PUBLIC_ENV === 'a11y';
};

export const isLocalhost = () => {
	return environment.PUBLIC_ENV === 'local';
};

export const isDev = () => {
	return environment.PUBLIC_ENV === 'develop';
};

export const isLocalhostOrE2eOrA11y = (): boolean => {
	return isLocalhost() || isE2e() || isA11y();
};
